export class ReqExportCryptoKeys {
  path: string;
  logUser: string;
  countryId: string[];
  includeKeys: boolean;
  includeLocks: boolean;
}
